import { render, staticRenderFns } from "./NewVoteButton.vue?vue&type=template&id=2e64c7b3"
import script from "./NewVoteButton.vue?vue&type=script&lang=ts"
export * from "./NewVoteButton.vue?vue&type=script&lang=ts"
import style0 from "./NewVoteButton.vue?vue&type=style&index=0&id=2e64c7b3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports